<template>
    <div>
        <div class="simple-form">
            <div class="form-group" v-if="contractId != null">
                <div class="form-label">
                    <label>合同编号</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{contractNo}}</span>
                    </div>
                </div>
            </div>
            <div class="form-group" v-if="orderId != null">
                <div class="form-label">
                    <label>订单编号</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{orderNo}}</span>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>金额(元)</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{parseFloat(amount || 0).toFixed(2)}}</span>
                    </div>
                </div>
            </div>
            <el-form :model="payInfo" :rules="checkPay" ref="ruleForm" class="demo-ruleForm">
                <!--<div class="form-group" v-if="payPhaseTplId != null && payPhaseTplId != -1">-->
                <!--<div class="form-label">-->
                <!--<label>当前阶段</label>-->
                <!--</div>-->
                <!--<div class="form-value">-->
                <!--<el-input class="bottom-line width-2x" v-model="payInfo.payPhaseName" :disabled="true"></el-input>-->
                <!--<i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择付款阶段" @click="selectPayPhaseTplItem()"></i>-->
                <!--<a class="swb-btn-link" @click="removePayPhase()">移除</a>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="form-group" v-if="payPhaseTplId != null && payPhaseTplId != -1">-->
                <!--<div class="form-label">-->
                <!--<label>阶段比例(%)</label>-->
                <!--</div>-->
                <!--<div class="form-value">-->
                <!--<span>{{payInfo.ratio || ''}}</span>-->
                <!--</div>-->
                <!--</div>-->
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">预付金额(元)</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="amountPre">
                            <el-input class="width-2x" v-model="payInfo.amountPre" @change="amountPreChange"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">支付主题</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="subject">
                            <el-input class="width-2x" v-model="payInfo.subject"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">付款形式</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="payForm">
                            <el-radio-group v-model="payInfo.payForm">
                                <el-radio v-for="item in payFormList" :label="item.value">
                                    <span>{{item.text}}</span>
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">员工借款</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="staffLoan">
                            <el-radio-group v-model="payInfo.staffLoan">
                                <el-radio :label="true">是</el-radio>
                                <el-radio :label="false">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>付款银行卡号</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="buyerCardNo">
                            <el-input class="width-2x" v-model="payInfo.buyerCardNo"></el-input>
                            <a class="swb-btn-link" @click="selectBuyerBankAcc()" v-if="buyerRealComId != null && buyerRealComId > 0">选择</a>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>付款银行名称</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="buyerBankName">
                            <el-input class="width-2x" v-model="payInfo.buyerBankName"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>付款账号名称</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="buyerAcctName">
                            <el-input class="width-2x" v-model="payInfo.buyerAcctName"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>付款账号</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="buyerAcctNo">
                            <el-input class="width-2x" v-model="payInfo.buyerAcctNo"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>收款银行卡号</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="sellerCardNo">
                            <el-input class="width-2x" v-model="payInfo.sellerCardNo"></el-input>
                            <a class="swb-btn-link" @click="selectBankAcc()" v-if="sellerRealComId != null && sellerRealComId > 0">选择</a>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>收款银行名称</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="sellerBankName">
                            <el-input class="width-2x" v-model="payInfo.sellerBankName"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>收款账号名称</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="sellerAcctName">
                            <el-input class="width-2x" v-model="payInfo.sellerAcctName"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>收款账号</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="sellerAcctNo">
                            <el-input class="width-2x" v-model="payInfo.sellerAcctNo"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>申请描述</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="applyDesc">
                            <textarea class="width-2x" placeholder="请输入" v-model="payInfo.applyDesc"></textarea>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>备注</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="memo">
                            <textarea class="width-2x" placeholder="请输入" v-model="payInfo.memo"></textarea>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'

    import {openPayPhaseTplItemListForSelectDlg} from '../payPhase/showDlg'
    import {selectRealComBankAcctDialog} from '../merchtFinac/selectDlg'

    import contractApi from '../../api/contract'
    import merchtComnApi from '../../api/merchtComn'

    export default{
        name: 'swb-pay-pre-info',
        avlActions: '',
        avlScopes: 'retailer',
        desc: '金额预付',
        props: {
            contractId: {
                type: Number,
                default: null
            },
            contractNo: {
                type: String,
                default: null
            },
            payPhaseTplId: {
                type: Number,
                default: null
            },
            orderType: {
                type: Number,
                default: null
            },
            orderId: {
                type: Number,
                default: null
            },
            orderNo: {
                type: String,
                default: null
            },
            sellerRealComId: {
                type: Number,
                default: null
            },
            buyerRealComId: {
                type: Number,
                default: null
            },
            amount: {
                type: Number,
                default: null
            }
        },
        data: function () {
            // 校验
            let self = this;
            let amountPreCheck = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('预付金额不能为空'));
                } else {
                    if (!Utils.isMoneyStr(value)) {
                        callback(new Error('必须是金额'));
                    } else {
                        let val = parseFloat(value);
                        if (val <= 0) {
                            callback(new Error('申请金额必须大于0'));
                        } else {
                            let regex = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
                            if (regex.test(val)) {
                                callback();
                            } else {
                                callback(new Error('输入的金额不能超过两位小数'));
                            }
                        }
                    }
                }
            };
            let checkSubject = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('支付主题不能为空'));
                } else {
                    callback();
                }
            };
            // 返回值
            return {
                //
                payInfo: {
                    payForm: getEnumInfoWith("payForm", "name", "Trans").value,
                    staffLoan: false
                },
                payFormList: getEnumList("payForm"),
                // 校验
                checkPay: {
                    amountPre: [{
                        validator: amountPreCheck,
                        trigger: 'blur'
                    }],
                    subject: [{
                        validator: checkSubject,
                        trigger: 'blur'
                    }],
                },
                contranct: {}
            }
        },
        created: function () {
            if (Utils.isNoB(this.contractId) && Utils.isNoB(this.orderId)) {
                MsgBox.warning("参数错误!");
                return;
            }
            //
            if (!Utils.isNoB(this.contractId) && this.contractId > 0) {
                this.getContractInfo(this.contractId);
            } else if (!Utils.isNoB(this.sellerRealComId) && this.sellerRealComId > 0) {
                // 获取卖方默认收款账号信息
                this.getSellerBankAccInfo();
            }
            //
            if (!Utils.isNoB(this.buyerRealComId) && this.buyerRealComId > 0) {
                // 获取买方默认收款账号信息
                this.getBuyerBankAccInfo();
            }
        },
        methods: {
            getContractInfo: function (contractId) {
                let self = this;
                let postData = {};
                postData.id = contractId;
                //
                let lastMsgBoxDlg = MsgBox.loading();
                contractApi.getContractInfo(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if (result.type == "info") {
                        let contranct = result.data;
                        //
                        let sellerCardNo = contranct.sndPartyCardNo || null;
                        let sellerBankName = contranct.sndPartyBankName || null;
                        let sellerAcctName = contranct.sndPartyAcctName || null;
                        let sellerAcctNo = contranct.sndPartyAcctNo || null;
                        if (!Utils.isNoB(sellerCardNo) || !Utils.isNoB(sellerBankName) || !Utils.isNoB(sellerAcctName) || !Utils.isNoB(sellerAcctNo)) {
                            let payInfo = self.payInfo || {};
                            payInfo.sellerCardNo = sellerCardNo;
                            payInfo.sellerBankName = sellerBankName;
                            payInfo.sellerAcctName = sellerAcctName;
                            payInfo.sellerAcctNo = sellerAcctNo;
                            //
                            self.payInfo = Utils.merge({}, payInfo);
                        } else if (!Utils.isNoB(self.sellerRealComId) && self.sellerRealComId > 0) {
                            self.getSellerBankAccInfo();
                        }
                        //
                        self.contranct = Utils.merge({}, contranct);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取卖方默认收款账号信息
            getSellerBankAccInfo: function () {
                let self = this;
                let postData = {};
                postData.realComId = self.sellerRealComId;
                postData.acctUsage = getEnumInfoWith('bankAcctUsage', 'name', 'Shroff').value;
                //
                let lastMsgBoxDlg = MsgBox.loading();
                merchtComnApi.getRealComBankAcctDefaulted(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if (result.type == "info") {
                        let bankAcct = result.data || {};
                        //
                        if (!Utils.isNoB(bankAcct) && bankAcct.id > 0) {
                            let payInfo = self.payInfo || {};
                            payInfo.sellerCardNo = bankAcct.cardNo;
                            payInfo.sellerBankName = bankAcct.bankName;
                            payInfo.sellerAcctName = bankAcct.acctName;
                            payInfo.sellerAcctNo = bankAcct.acctNo;
                            //
                            self.payInfo = Utils.merge({}, payInfo);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取买方默认收款账号信息
            getBuyerBankAccInfo: function () {
                let self = this;
                let postData = {};
                postData.realComId = self.buyerRealComId;
                postData.acctUsage = getEnumInfoWith('bankAcctUsage', 'name', 'Payment').value;
                //
                let lastMsgBoxDlg = MsgBox.loading();
                merchtComnApi.getRealComBankAcctDefaulted(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if (result.type == "info") {
                        let bankAcct = result.data || {};
                        //
                        if (!Utils.isNoB(bankAcct) && bankAcct.id > 0) {
                            let payInfo = self.payInfo || {};
                            payInfo.buyerCardNo = bankAcct.cardNo;
                            payInfo.buyerBankName = bankAcct.bankName;
                            payInfo.buyerAcctName = bankAcct.acctName;
                            payInfo.buyerAcctNo = bankAcct.acctNo;
                            //
                            self.payInfo = Utils.merge({}, payInfo);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 选择付款账号
            selectBuyerBankAcc: function () {
                let self = this;
                let params = {
                    realComId: self.buyerRealComId,
                    checkBox: false,
                    usage: getEnumInfoWith('bankAcctUsage', 'name', 'Payment').value
                };
                selectRealComBankAcctDialog(params, function (bankAcct) {
                    bankAcct = bankAcct || {};
                    if (!Utils.isNoB(bankAcct) && bankAcct.id > 0) {
                        let payInfo = self.payInfo || {};
                        payInfo.buyerCardNo = bankAcct.cardNo;
                        payInfo.buyerBankName = bankAcct.bankName;
                        payInfo.buyerAcctName = bankAcct.acctName;
                        payInfo.buyerAcctNo = bankAcct.acctNo;
                        //
                        self.payInfo = Utils.merge({}, payInfo);
                    } else {
                        MsgBox.warning("请选择银行卡信息！");
                    }
                });
            },
            // 选择银行卡
            selectBankAcc: function () {
                let self = this;
                let params = {
                    realComId: self.sellerRealComId,
                    checkBox: false,
                    usage: getEnumInfoWith('bankAcctUsage', 'name', 'Shroff').value
                };
                selectRealComBankAcctDialog(params, function (bankAcct) {
                    bankAcct = bankAcct || {};
                    if (!Utils.isNoB(bankAcct) && bankAcct.id > 0) {
                        let payInfo = self.payInfo || {};
                        payInfo.sellerCardNo = bankAcct.cardNo;
                        payInfo.sellerBankName = bankAcct.bankName;
                        payInfo.sellerAcctName = bankAcct.acctName;
                        payInfo.sellerAcctNo = bankAcct.acctNo;
                        //
                        self.payInfo = Utils.merge({}, payInfo);
                    } else {
                        MsgBox.warning("请选择银行卡信息！");
                    }
                });
            },
            // 预付金额
            amountPreChange: function () {
                let payInfo = this.payInfo || {};
                if (!Utils.isNoB(payInfo.amountPre)) {
                    payInfo.amountPre = parseFloat(payInfo.amountPre || 0).toFixed(2);
                }
                this.payInfo = Utils.merge({}, payInfo);
            },
            // 选择付款阶段
            selectPayPhaseTplItem: function () {
                let self = this;
                let payInfo = self.payInfo || {};
                let checkedIds = [];
                if (!Utils.isNoB(payInfo.payPhaseId)) {
                    checkedIds.push(payInfo.payPhaseId);
                }
                let params = {
                    tplId: self.payPhaseTplId,
                    checkedIds: checkedIds
                };
                openPayPhaseTplItemListForSelectDlg(params, function (payPhaseTplItem, theDlg) {
                    theDlg.close();
                    payInfo.payPhaseId = payPhaseTplItem.id;
                    payInfo.payPhaseName = payPhaseTplItem.name;
                    payInfo.ratio = parseFloat(payPhaseTplItem.ratio || 0).toFixed(2);
                    //
                    self.payInfo = Utils.merge({}, payInfo);
                });
            },
            // 移除付款阶段
            removePayPhase: function (index) {
                let payInfo = this.payInfo || {};
                payInfo.payPhaseId = null;
                payInfo.payPhaseName = null;
                payInfo.ratio = null;
                this.payInfo = Utils.merge({}, payInfo);
            },
            //
            getDlgResult: function () {
                let self = this;
                let result = {};
                // 表单校验
                self.$refs['ruleForm'].validate(function (valid) {
                    if (valid) {
                        //
                        let payInfo = self.payInfo || {};
                        if (!Utils.isNoB(self.contractId)) {
                            payInfo.contractId = self.contractId;
                            payInfo.contractNo = self.contractNo;
                            payInfo.payPhaseTplId = self.payPhaseTplId;
                            //
                            let contranct = self.contranct || {};
                            if (!Utils.isNoB(contranct) && contranct.id > 0) {
                                let sellerCardNo = contranct.sndPartyCardNo || null;
                                let sellerBankName = contranct.sndPartyBankName || null;
                                let sellerAcctName = contranct.sndPartyAcctName || null;
                                let sellerAcctNo = contranct.sndPartyAcctNo || null;
                                let needHint = false;
                                if (!Utils.isNoB(sellerCardNo) && sellerCardNo != payInfo.sellerCardNo) {
                                    needHint = true;
                                }
                                if (!Utils.isNoB(sellerBankName) && sellerBankName != payInfo.sellerBankName) {
                                    needHint = true;
                                }
                                if (!Utils.isNoB(sellerAcctName) && sellerAcctName != payInfo.sellerAcctName) {
                                    needHint = true;
                                }
                                if (!Utils.isNoB(sellerAcctNo) && sellerAcctNo != payInfo.sellerAcctNo) {
                                    needHint = true;
                                }
                                if (Utils.isTrue(needHint)) {
                                    payInfo.hintMsg = '您好！收款的银行卡信息与签订合同中的银行卡信息不一致，请您再次确认是否使用！';
                                }
                            }
                        }
                        if (!Utils.isNoB(self.orderId)) {
                            payInfo.orderType = self.orderType;
                            payInfo.orderId = self.orderId;
                            payInfo.orderNo = self.orderNo;
                        }
                        //
                        result.type = 'info';
                        result.data = payInfo;
                    } else {
                        result.type = 'warn';
                        result.message = "校验失败！";
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/settle/PayPreInfo.vue